import { action, observable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { FacilityOrderTemplateValidationService } from 'application/facility-order/services';
import moment from 'moment';

@applicationContext
class FacilityOrderTemplateValidationModalViewStore extends BaseViewStore {
    @observable accessor items = [];
    constructor(rootStore, componentProps) {
        const modalParams = componentProps.modalParams;
        const service = new FacilityOrderTemplateValidationService(rootStore.application.baasic.apiClient);
        super(rootStore)

        this.modalParams = modalParams;

        this.service = service;
        fetch([this.find()]);
    }

    async find(){
        const facilityOrderTemplateId = this.modalParams.data && this.modalParams.data.facilityOrderTemplateId;
        const response = await this.service.find({ facilityOrderTemplateId: facilityOrderTemplateId, embed:"CoreUser" });
        this.items = response.data.item;
    }

    @action.bound
    onChange(item) {
        item.isResolved = !item.isResolved;
        if(item.isResolved){
            item.resolvedByUserId = this.rootStore.userStore.user.id;
            item.coreUser = this.rootStore.userStore.user;
            item.dateResolved = moment();
        }else{
            item.coreUser = null;
            item.dateResolved = null;
        }
    }

    @action.bound
    async updateResource() {
        try {
            await this.service.bulkUpdate(this.items.map(x=>{
                return {
                    ...x,
                    coreUser:null
                }
            }));
            this.modalParams.close();   

            this.rootStore.notificationStore.success("Validations successfully resolved.");
        }
        catch(err) {
            this.rootStore.notificationStore.error("Error occured while resolving validations.");
        }
    }
}

export default FacilityOrderTemplateValidationModalViewStore;